import { createFileRoute } from "@tanstack/react-router";
import { previewSplitRoute, PreviewSplitPage } from "@/features/preview-split";

export const Route = createFileRoute("/preview-split")({
    loader: previewSplitRoute.loader,
    head: previewSplitRoute.head,
    component: PreviewSplitPage,
});
